// extracted by mini-css-extract-plugin
export default {"defaultToParentFieldText":"DefaultToParentField_defaultToParentFieldText__bsgvl","defaultToParentFieldWrapper":"DefaultToParentField_defaultToParentFieldWrapper__L2zV5"};